(() => {
'use strict';
const root = document.getElementById('mayhem-support');
if (!root || root.dataset.ready) return;
root.dataset.ready = 'true';
const launcher = root.querySelector('.mhs-launcher');
const dialog = root.querySelector('dialog');
if (!dialog || typeof dialog.showModal !== 'function') return;
let drag = null;
let suppressClick = 0;
let lastFocus = launcher;
const store = (key,value) => {try {if(value===undefined)return sessionStorage.getItem(key);sessionStorage.setItem(key,value);}catch{}return null;};
const open = () => {lastFocus=document.activeElement;dialog.showModal();launcher.setAttribute('aria-expanded','true');};
  const move = (side, top = null, remember = true) => {
    root.dataset.side = side === 'left' ? 'left' : 'right';
    const mobile = matchMedia('(max-width:749px)').matches;
    launcher.style.left = side === 'left' ? mobile && !Number.isFinite(top) ? '76px' : '16px' : 'auto';
    launcher.style.right = side === 'left' ? 'auto' : '16px';
    if (mobile && Number.isFinite(top)) {
      top = Math.min(Math.max(12,top),Math.max(12,innerHeight - launcher.offsetHeight - 92));
      launcher.style.top = `${top}px`; launcher.style.bottom = 'auto';
    } else { top = null; launcher.style.top = 'auto'; launcher.style.bottom = ''; }
    if (remember) store('mayhem:support-position',JSON.stringify({side:root.dataset.side,top}));
  };
  let position;
  try { position = JSON.parse(store('mayhem:support-position') || 'null'); } catch {}
  move(position?.side || root.dataset.defaultSide,position?.top ?? null,false);
  // Keep the launcher accessible above Shopify's cookie notice on first mobile visit.
  // This does not dismiss, alter, or interfere with visitor consent.
  let consentFrame = 0;
  const updateConsentClearance = () => {
    consentFrame = 0;
    const banner = document.getElementById('shopify-pc__banner');
    let clearance = '';
    if (matchMedia('(max-width:749px)').matches && banner) {
      const style = getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      if (style.display !== 'none' && style.visibility !== 'hidden' &&
          rect.width > 0 && rect.height > 0 && rect.top > 0 && rect.top < innerHeight) {
        const wanted = Math.ceil(innerHeight - rect.top + 16);
        const maxAllowed = innerHeight - launcher.offsetHeight - 16;
        if (wanted <= maxAllowed) clearance = Math.max(100,wanted) + 'px';
      }
    }
    if (root.style.getPropertyValue('--mhs-consent-clearance') !== clearance) {
      if (clearance) root.style.setProperty('--mhs-consent-clearance',clearance);
      else root.style.removeProperty('--mhs-consent-clearance');
    }
  };
  const scheduleConsentClearance = () => {
    if (!consentFrame) consentFrame = requestAnimationFrame(updateConsentClearance);
  };
  new MutationObserver(scheduleConsentClearance).observe(document.body,{
    subtree:true,childList:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']
  });
  addEventListener('resize',scheduleConsentClearance);
  addEventListener('load',scheduleConsentClearance,{once:true});
  scheduleConsentClearance();
  launcher.setAttribute('role','button');
  launcher.addEventListener('keydown',event => { if (event.key === ' ') { event.preventDefault(); open(); } });
  launcher.addEventListener('pointerdown',event => {
    if (!matchMedia('(max-width:749px)').matches || event.button !== 0) return;
    const rect = launcher.getBoundingClientRect();
    drag = {id:event.pointerId,x:event.clientX,y:event.clientY,left:rect.left,top:rect.top,moved:false};
    launcher.setPointerCapture(event.pointerId);
  });
  launcher.addEventListener('pointermove',event => {
    if (!drag || drag.id !== event.pointerId) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (!drag.moved && Math.hypot(dx,dy) < 10) return;
    drag.moved = true;
    launcher.style.left = `${Math.min(Math.max(8,drag.left+dx),innerWidth-launcher.offsetWidth-8)}px`;
    launcher.style.top = `${Math.min(Math.max(12,drag.top+dy),Math.max(12,innerHeight-launcher.offsetHeight-92))}px`;
    launcher.style.right = 'auto'; launcher.style.bottom = 'auto';
  });
  const endDrag = event => {
    if (!drag || event.pointerId !== drag.id) return;
    const moved = drag.moved;
    drag = null;
    if (moved) {
      suppressClick = Date.now()+500;
      const rect = launcher.getBoundingClientRect();
      move(rect.left+rect.width/2 < innerWidth/2 ? 'left':'right',rect.top);
    }
    if (launcher.hasPointerCapture(event.pointerId)) launcher.releasePointerCapture(event.pointerId);
  };
  launcher.addEventListener('pointerup',endDrag);
  launcher.addEventListener('pointercancel',endDrag);
  addEventListener('resize',() => { const top = parseFloat(launcher.style.top); move(root.dataset.side,Number.isFinite(top)?top:null,false); });
  launcher.addEventListener('click',event => { event.preventDefault(); if (Date.now() >= suppressClick) open(); });

root.addEventListener('click',event => {
const button=event.target.closest('button');
if(!button)return;
if(button.hasAttribute('data-mhs-close'))dialog.close();
else if(button.hasAttribute('data-mhs-side'))move(button.dataset.mhsSide);
else if(button.hasAttribute('data-mhs-reset'))move(root.dataset.defaultSide);
});
// Shopify Forms mounts its verification outside this dialog. Hand off the
// browser top layer while keeping the embedded form and its state mounted.
root.addEventListener('mayhem:contact-mode',event=>{
  if(!dialog.open)return;
  const focused=document.activeElement;
  dialog.close();
  dialog.classList.toggle('mhs-external-form',event.detail===true);
  if(event.detail===true)dialog.show();else dialog.showModal();
  focused?.focus({preventScroll:true});
});
dialog.addEventListener('close',()=>{
  if(dialog.open)return; // close event from switching dialog presentation
  dialog.classList.remove('mhs-external-form');
  launcher.setAttribute('aria-expanded','false');lastFocus?.focus();
});
dialog.addEventListener('keydown',event=>{
  if(event.key==='Escape'&&dialog.classList.contains('mhs-external-form')){
    event.preventDefault();dialog.close();
  }
});
})();

